<template>
  <div class="page flex-col">
    <!-- 头部导航组件 -->
    <HeaderNav />
    
    <div class="box_1 flex-col">
      <!-- 统一的顶部装饰和图片 -->
      <div class="box_1-spacer flex-col"></div>
      <div class="box_2 flex-col"></div>
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        :src="getImageUrl(siteConfig?.config?.['pic_在线购墓']) || '/files/images/M7.jpg'"
      />
      <div class="news-content flex-col">
        <div class="news-header flex-col">
          <h1 class="news-title">在线购墓</h1>
          <p class="news-subtitle">ONLINE PURCHASE OF BURIAL PLOTS</p>
        </div>
      </div>

      <div class="box_8 flex-row justify-between">
        <div class="box_9 flex-col">
          <div class="box_10 flex-col">
            <div class="text-wrapper_1 flex-row">
              <span 
                v-for="(area, index) in cemeteryList" 
                :key="area.id"
                :class="getAreaTextClass(area, index)"
                @click="selectArea(area)"
                style="cursor: pointer;"
              >{{ area.areaName || area.direction }}</span>
            </div>
          </div>
          <div class="box_12 flex-row" v-if="selectedArea && selectedArea.burialTypes">
            <div 
              v-for="(burialType, index) in selectedArea.burialTypes" 
              :key="burialType.id"
              :class="getBurialTypeWrapperClass(burialType, index)"
              @click="selectBurialType(burialType)"
              style="cursor: pointer;"
            >
              <span :class="getBurialTypeTextClass(burialType, index)">{{ burialType.label || '未知类型' }}</span>
            </div>
          </div>
          <div class="box_13 flex-col"></div>
          <!-- box_14: 显示所有排数作为可点击选项 -->
          <div class="box_14 flex-row justify-between">
            <div 
              v-for="(row, rowIndex) in displayRows" 
              :key="row.id || rowIndex"
              class="text-wrapper_6"
              :class="{ 'row-selected': selectedRow && selectedRow.id === row.id }"
              @click="selectRow(row)"
              style="cursor: pointer;"
            >
              <span class="text_18">{{ row.rowNumber }}</span>
              <span class="text_19">排</span>
            </div>
          </div>
          <!-- box_15: 显示选中排下的所有 plots -->
          <div class="box_15 flex-row" v-if="selectedRowPlots.length > 0">
            <div 
              v-for="plot in selectedRowPlots" 
              :key="plot.id"
              :class="getPlotWrapperClass(plot)"
              @click="!plot.isLocked && selectPlot(plot)"
              :style="plot.isLocked ? 'cursor: not-allowed; opacity: 0.5;' : 'cursor: pointer;'"
            >
              <span :class="getPlotTextClass(plot)">{{ plot.plotNumber }}号</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 产品列表独立容器，放在选择区域下方 -->
      <div class="product-list-wrapper flex-col">
        <div class="box_17 flex-row justify-between" v-if="productList.length > 0">
          <div 
            v-for="(product, index) in productList.slice(0, 4)" 
            :key="product.id"
            :class="getProductWrapperClass(index)"
            @click="goToProductDetail(product.id)"
            style="cursor: pointer;"
          >
            <div 
              :class="getProductImageClass(index)"
              :style="product.cover ? { backgroundImage: `url(${product.cover})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}"
            ></div>
            <span :class="getProductTitleClass(index)">{{ product.title || '暂无标题' }}</span>
            <div :class="getProductPriceClass(index)">
              <span :class="getProductPriceLabelClass(index)">参考价：</span>
              <div :class="getProductPriceWrapperClass(index)">
                <span :class="getProductPriceSymbolClass(index)">¥</span>
                <span :class="getProductPriceValueClass(index)">{{ formatPrice(product.price) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box_20 flex-row justify-between" v-if="productList.length > 4">
          <div 
            v-for="(product, index) in productList.slice(4, 8)" 
            :key="product.id"
            :class="getProductWrapperClass2(index)"
            @click="goToProductDetail(product.id)"
            style="cursor: pointer;"
          >
            <div 
              :class="getProductImageClass2(index)"
              :style="product.cover ? { backgroundImage: `url(${product.cover})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}"
            ></div>
            <span :class="getProductTitleClass2(index)">{{ product.title || '暂无标题' }}</span>
            <div :class="getProductPriceClass2(index)">
              <span :class="getProductPriceLabelClass2(index)">参考价：</span>
              <div :class="getProductPriceWrapperClass2(index)">
                <span :class="getProductPriceSymbolClass2(index)">¥</span>
                <span :class="getProductPriceValueClass2(index)">{{ formatPrice(product.price) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>
<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getSiteConfig } from '@/store/siteConfig';
import { getCemeteryAreaList } from '@/api/home';
import { getImageUrl } from '@/config/api';

export default {
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      constants: {},
      cemeteryList: [],
      selectedArea: null,
      selectedBurialType: null,
      selectedRow: null, // 选中的排
      selectedPlot: null
    };
  },
  computed: {
    siteConfig() {
      return getSiteConfig();
    },
    // 获取显示的行列表（根据选中的安葬类型，返回所有 rows）
    displayRows() {
      if (!this.selectedBurialType || !this.selectedBurialType.rows) {
        return [];
      }
      // 返回所有 rows，不过滤
      return this.selectedBurialType.rows;
    },
    // 获取选中排的 plots
    selectedRowPlots() {
      if (!this.selectedRow || !this.selectedRow.plots) {
        return [];
      }
      return this.selectedRow.plots;
    },
    // 获取产品列表（从选中的墓位的 products 中获取）
    productList() {
      if (!this.selectedPlot || !this.selectedPlot.products) {
        return [];
      }
      return this.selectedPlot.products;
    }
  },
  created() {
    // 获取购墓列表
    this.fetchCemeteryList();
  },
  methods: {
    // 获取购墓列表
    async fetchCemeteryList() {
      try {
        const res = await getCemeteryAreaList();
        if (res.code === 0 && res.data && res.data.list) {
          this.cemeteryList = res.data.list;
          // 默认选择第一个区域
          if (this.cemeteryList.length > 0) {
            this.selectedArea = this.cemeteryList[0];
            // 默认选择第一个安葬类型
            if (this.selectedArea.burialTypes && this.selectedArea.burialTypes.length > 0) {
              this.selectedBurialType = this.selectedArea.burialTypes[0];
              // 默认选择第一个排（如果有）
              if (this.selectedBurialType.rows && this.selectedBurialType.rows.length > 0) {
                this.selectedRow = this.selectedBurialType.rows[0];
              }
            }
          }
        }
      } catch (error) {
        console.error('获取购墓列表失败:', error);
      }
    },
    // 选择区域
    selectArea(area) {
      this.selectedArea = area;
      // 选择区域后，默认选择第一个安葬类型
      if (area.burialTypes && area.burialTypes.length > 0) {
        this.selectedBurialType = area.burialTypes[0];
        // 默认选择第一个排（如果有）
        if (this.selectedBurialType.rows && this.selectedBurialType.rows.length > 0) {
          this.selectedRow = this.selectedBurialType.rows[0];
        } else {
          this.selectedRow = null;
        }
      } else {
        this.selectedBurialType = null;
        this.selectedRow = null;
      }
      // 清空选中的墓位
      this.selectedPlot = null;
    },
    // 选择安葬类型
    selectBurialType(burialType) {
      this.selectedBurialType = burialType;
      // 选择类型后，默认选择第一个排（如果有）
      if (burialType.rows && burialType.rows.length > 0) {
        this.selectedRow = burialType.rows[0];
      } else {
        this.selectedRow = null;
      }
      // 清空选中的墓位和产品列表
      this.selectedPlot = null;
    },
    // 选择排
    selectRow(row) {
      this.selectedRow = row;
      // 选择排后，清空选中的墓位和产品列表
      this.selectedPlot = null;
    },
    // 获取区域文本的class
    getAreaTextClass(area, index) {
      // 如果选中，使用绿色文字样式（text_8），否则使用普通样式
      const isSelected = this.selectedArea && this.selectedArea.id === area.id;
      if (isSelected) {
        return 'text_8'; // 选中时使用 text_8（绿色文字）
      } else {
        // 未选中时根据 index 返回对应的 class
        const classes = [
          'text_6',
          'text_7',
          'text_9',
          'text_10',
          'text_11',
          'text_12',
          'text_13'
        ];
        return classes[index] || 'text_6';
      }
    },
    // 获取安葬类型包装器的class
    getBurialTypeWrapperClass(burialType, index) {
      // 如果选中，使用深色背景样式（text-wrapper_4），否则使用普通样式
      const isSelected = this.selectedBurialType && this.selectedBurialType.id === burialType.id;
      if (isSelected) {
        return 'text-wrapper_4 flex-col'; // 选中时使用 text-wrapper_4（深色背景）
      } else {
        // 未选中时根据 index 返回对应的 class
        const classes = [
          'text-wrapper_2 flex-col',
          'text-wrapper_3 flex-col',
          'text-wrapper_5 flex-col'
        ];
        return classes[index] || 'text-wrapper_2 flex-col';
      }
    },
    // 获取安葬类型文本的class
    getBurialTypeTextClass(burialType, index) {
      // 如果选中，使用白色文字样式（text_16），否则使用普通样式
      const isSelected = this.selectedBurialType && this.selectedBurialType.id === burialType.id;
      if (isSelected) {
        return 'text_16'; // 选中时使用 text_16（白色文字）
      } else {
        // 未选中时根据 index 返回对应的 class
        const classes = [
          'text_14',
          'text_15',
          'text_17'
        ];
        return classes[index] || 'text_14';
      }
    },
    // 选择墓位
    selectPlot(plot) {
      // 如果墓位已锁定，不允许选择
      if (plot.isLocked) {
        return;
      }
      this.selectedPlot = plot;
    },
    // 获取墓位包装器的class（第一行）
    getPlotWrapperClass(plot) {
      // 如果锁定，使用锁定样式
      if (plot.isLocked) {
        return 'text-wrapper_8 flex-col plot-locked';
      }
      // 如果选中，使用有边框的样式（text-wrapper_7），否则使用无边框的样式（text-wrapper_8）
      const isSelected = this.selectedPlot && this.selectedPlot.id === plot.id;
      if (isSelected) {
        return 'text-wrapper_7 flex-col';
      } else {
        // 未选中时统一使用 text-wrapper_8（无边框）
        return 'text-wrapper_8 flex-col';
      }
    },
    // 获取墓位文本的class（第一行）
    getPlotTextClass(plot) {
      // 如果锁定，使用锁定文字样式
      if (plot.isLocked) {
        return 'text_21 plot-text-locked';
      }
      // 如果选中，使用绿色文字（text_20），否则使用灰色文字（text_21）
      const isSelected = this.selectedPlot && this.selectedPlot.id === plot.id;
      if (isSelected) {
        return 'text_20';
      } else {
        // 未选中时统一使用 text_21（灰色文字）
        return 'text_21';
      }
    },
    // 获取墓位包装器的class（第二行）
    getPlotWrapperClass2(plot) {
      // 如果锁定，使用锁定样式
      if (plot.isLocked) {
        return 'text-wrapper_27 flex-col plot-locked';
      }
      // 如果选中，使用有边框的样式（text-wrapper_26），否则使用无边框的样式（text-wrapper_27）
      const isSelected = this.selectedPlot && this.selectedPlot.id === plot.id;
      if (isSelected) {
        return 'text-wrapper_26 flex-col';
      } else {
        // 未选中时统一使用 text-wrapper_27（无边框）
        return 'text-wrapper_27 flex-col';
      }
    },
    // 获取墓位文本的class（第二行）
    getPlotTextClass2(plot) {
      // 如果锁定，使用锁定文字样式
      if (plot.isLocked) {
        return 'text_40 plot-text-locked';
      }
      // 如果选中，使用绿色文字（text_39），否则使用灰色文字（text_40）
      const isSelected = this.selectedPlot && this.selectedPlot.id === plot.id;
      if (isSelected) {
        return 'text_39';
      } else {
        // 未选中时统一使用 text_40（灰色文字）
        return 'text_40';
      }
    },
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    },
    // 格式化价格
    formatPrice(price) {
      if (!price) {
        return '无参考价';
      }
      const priceNum = parseFloat(price);
      if (isNaN(priceNum)) {
        return '无参考价';
      }
      // 如果价格大于等于10000，显示为"w"单位
      if (priceNum >= 10000) {
        return (priceNum / 10000).toFixed(1) + 'w';
      }
      return priceNum.toFixed(2);
    },
    // 跳转到产品详情页
    goToProductDetail(productId) {
      if (productId) {
        this.$router.push({
          path: `/product/${productId}`,
          query: {
            product_id: productId
          }
        });
      }
    },
    // 获取产品包装器的class（第一行）
    getProductWrapperClass(index) {
      const classes = [
        'group_4 flex-col',
        'group_7 flex-col',
        'group_8 flex-col',
        'group_9 flex-col'
      ];
      return classes[index] || 'group_4 flex-col';
    },
    // 获取产品图片的class（第一行）
    getProductImageClass(index) {
      const classes = [
        'group_5 flex-col',
        'block_1 flex-col',
        'box_18 flex-col',
        'block_3 flex-col'
      ];
      return classes[index] || 'group_5 flex-col';
    },
    // 获取产品标题的class（第一行）
    getProductTitleClass(index) {
      const classes = [
        'text_48',
        'text_52',
        'text_56',
        'text_60'
      ];
      return classes[index] || 'text_48';
    },
    // 获取产品价格的class（第一行）
    getProductPriceClass(index) {
      const classes = [
        'group_6 flex-row justify-between',
        'block_2 flex-row justify-between',
        'box_19 flex-row justify-between',
        'block_4 flex-row justify-between'
      ];
      return classes[index] || 'group_6 flex-row justify-between';
    },
    // 获取产品价格标签的class（第一行）
    getProductPriceLabelClass(index) {
      const classes = [
        'text_49',
        'text_53',
        'text_57',
        'text_61'
      ];
      return classes[index] || 'text_49';
    },
    // 获取产品价格包装器的class（第一行）
    getProductPriceWrapperClass(index) {
      const classes = [
        'text-wrapper_35',
        'text-wrapper_36',
        'text-wrapper_37',
        'text-wrapper_38'
      ];
      return classes[index] || 'text-wrapper_35';
    },
    // 获取产品价格符号的class（第一行）
    getProductPriceSymbolClass(index) {
      const classes = [
        'text_50',
        'text_54',
        'text_58',
        'text_62'
      ];
      return classes[index] || 'text_50';
    },
    // 获取产品价格值的class（第一行）
    getProductPriceValueClass(index) {
      const classes = [
        'text_51',
        'text_55',
        'text_59',
        'text_63'
      ];
      return classes[index] || 'text_51';
    },
    // 获取产品包装器的class（第二行）
    getProductWrapperClass2(index) {
      const classes = [
        'group_10 flex-col',
        'group_11 flex-col',
        'group_12 flex-col',
        'group_13 flex-col'
      ];
      return classes[index] || 'group_10 flex-col';
    },
    // 获取产品图片的class（第二行）
    getProductImageClass2(index) {
      const classes = [
        'box_21 flex-col',
        'box_23 flex-col',
        'section_1 flex-col',
        'group_14 flex-col'
      ];
      return classes[index] || 'box_21 flex-col';
    },
    // 获取产品标题的class（第二行）
    getProductTitleClass2(index) {
      const classes = [
        'text_64',
        'text_68',
        'text_72',
        'text_76'
      ];
      return classes[index] || 'text_64';
    },
    // 获取产品价格的class（第二行）
    getProductPriceClass2(index) {
      const classes = [
        'box_22 flex-row justify-between',
        'box_24 flex-row justify-between',
        'section_2 flex-row justify-between',
        'group_15 flex-row justify-between'
      ];
      return classes[index] || 'box_22 flex-row justify-between';
    },
    // 获取产品价格标签的class（第二行）
    getProductPriceLabelClass2(index) {
      const classes = [
        'text_65',
        'text_69',
        'text_73',
        'text_77'
      ];
      return classes[index] || 'text_65';
    },
    // 获取产品价格包装器的class（第二行）
    getProductPriceWrapperClass2(index) {
      const classes = [
        'text-wrapper_39',
        'text-wrapper_40',
        'text-wrapper_41',
        'text-wrapper_42'
      ];
      return classes[index] || 'text-wrapper_39';
    },
    // 获取产品价格符号的class（第二行）
    getProductPriceSymbolClass2(index) {
      const classes = [
        'text_66',
        'text_70',
        'text_74',
        'text_78'
      ];
      return classes[index] || 'text_66';
    },
    // 获取产品价格值的class（第二行）
    getProductPriceValueClass2(index) {
      const classes = [
        'text_67',
        'text_71',
        'text_75',
        'text_79'
      ];
      return classes[index] || 'text_67';
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* 统一的顶部装饰和图片样式 */
.box_1-spacer {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100px !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.box_2 {
  background-color: rgba(0, 149, 151, 1) !important;
  width: 100% !important;
  max-width: 36px !important;
  height: 4px !important;
  margin: 50px auto 0 !important;
  box-sizing: border-box !important;
}

.image_1 {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: -53px auto 0 !important;
  object-fit: cover !important;
  display: block !important;
  box-sizing: border-box !important;
}

/* 隐藏在线购墓页面的下划线元素，统一使用 HeaderNav 组件的下划线 */
.box_3 {
  display: none !important;
}

/* FooterSection 相关样式已移至 ContactUsSection 组件 */

/* 统一所有墓位标签的样式，使其与001号保持一致 */
.text-wrapper_8,
.text-wrapper_9,
.text-wrapper_10,
.text-wrapper_11,
.text-wrapper_12,
.text-wrapper_13,
.text-wrapper_14,
.text-wrapper_15,
.text-wrapper_16,
.text-wrapper_17,
.text-wrapper_18,
.text-wrapper_19,
.text-wrapper_20,
.text-wrapper_21,
.text-wrapper_22,
.text-wrapper_23,
.text-wrapper_24,
.text-wrapper_25 {
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(0, 141, 138, 1) !important;
}

.text_21,
.text_22,
.text_23,
.text_24,
.text_25,
.text_26,
.text_27,
.text_28,
.text_29,
.text_30,
.text_31,
.text_32,
.text_33,
.text_34,
.text_35,
.text_36,
.text_37,
.text_38 {
  color: rgba(0, 141, 138, 1) !important;
}

/* 调整标签间距，不要太近也不要太远 */
.box_15 {
  justify-content: flex-start !important;
  gap: 8px !important; /* 设置合适的间距 */
  flex-wrap: wrap !important;
}

.box_15 > div {
  margin: 0 !important;
}

/* 第二行标签也设置合适的间距 */
.box_16 {
  justify-content: flex-start !important;
  gap: 8px !important; /* 设置合适的间距 */
  flex-wrap: wrap !important;
}

.box_16 > div {
  margin: 0 !important;
}

/* 确保未选中的标签没有边框和绿色文字 */
.text-wrapper_8,
.text-wrapper_27 {
  background-color: rgba(255, 255, 255, 0) !important;
  border: none !important;
}

/* 确保选中的标签有绿色边框和绿色文字 */
.text-wrapper_7 {
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(0, 141, 138, 1) !important;
}

.text-wrapper_26 {
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(0, 141, 138, 1) !important;
}

/* 未选中的文字颜色为灰色 */
.text_21,
.text_40 {
  color: rgba(92, 92, 92, 1) !important; /* 灰色文字 */
}

/* 选中的文字颜色为绿色 */
.text_20,
.text_39 {
  color: rgba(0, 141, 138, 1) !important; /* 绿色文字 */
}

/* box_10 内容垂直居中，文字左侧对齐 */
.box_10 {
  justify-content: center !important; /* 垂直方向居中 */
  align-items: flex-start !important; /* 水平方向左侧对齐 */
  padding-top: 0 !important;
}

/* 第一行标签左侧对齐，垂直居中 */
.text-wrapper_1 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 23px !important; /* 保持左侧对齐 */
}

/* 区域选择：选中时显示绿色文字和下划线 */
.text_8 {
  color: rgba(0, 141, 138, 1) !important; /* 绿色文字 */
  font-weight: 500 !important;
  position: relative !important;
  display: inline-block !important;
}

/* 区域选择：选中时显示蓝色下划线 */
.text_8::after {
  content: '' !important;
  position: absolute !important;
  bottom: -4px !important;
  left: 0 !important;
  width: 100% !important;
  height: 2px !important;
  background-color: rgba(0, 141, 138, 1) !important; /* 蓝色下划线 */
}

/* 产品列表独立容器，放在选择区域（box_8）下方 */
.product-list-wrapper {
  position: relative;
  width: 100%;
  margin-top: 50px;
}

/* product-list-wrapper - 自适应 */
.product-list-wrapper {
  width: 100% !important;
  max-width: 1920px !important;
  margin: 50px auto 0 !important;
  padding: 0 20px !important;
  box-sizing: border-box !important;
}

.product-list-wrapper .box_17 {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  max-width: 1200px !important;
  height: auto !important;
  min-height: 362px !important;
  margin: 0 auto !important;
  padding: 0 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: flex-start !important;
  flex-wrap: wrap !important;
  gap: 20px !important;
}

.product-list-wrapper .box_20 {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  max-width: 1200px !important;
  height: auto !important;
  min-height: 362px !important;
  margin: 40px auto 0 !important;
  padding: 0 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: flex-start !important;
  flex-wrap: wrap !important;
  gap: 20px !important;
}

/* 联系我们部分样式已移至 ContactUsSection 组件 */

/* 安葬类型：选中时显示深色背景和白色文字 */
.text-wrapper_4 {
  background-color: rgba(0, 141, 138, 1) !important; /* 深色背景 */
  border: 1px solid rgba(0, 141, 138, 1) !important;
}

.text_16 {
  color: rgba(255, 254, 254, 1) !important; /* 白色文字 */
}

/* box_6 - 改为上中下结构，横线在中间 */
.box_6 {
  flex-direction: column !important; /* 改为纵向布局 */
  align-items: flex-start !important; /* 左侧对齐 */
  justify-content: flex-start !important;
  gap: 8px !important; /* 统一设置较小的间距 */
}

/* text_3 - 上 */
.box_6 .text_3 {
  margin: 0 !important;
}

/* group_2 - 中（横线） */
.box_6 .group_2 {
  margin: 0 !important; /* 移除原有间距，使用 gap */
  margin-left: 5px !important; /* 保持原有的左边距 */
}

/* text_4 - 下 */
.box_6 .text_4 {
  margin: 0 !important; /* 移除原有间距，使用 gap */
}

/* box_7 - 宽度与 box_6 保持一致 */
.box_7 {
  width: 100% !important;
  max-width: 1200px !important; /* 与 box_6 相同的 max-width */
  padding: 0 20px !important; /* 与 box_6 相同的 padding */
  margin: 50px auto 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  box-sizing: border-box !important;
}

/* image_3 - 宽度与 box_6 保持一致 */
.box_7 .image_3 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  object-fit: cover !important;
  display: block !important;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .page {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
  }

  .box_1-spacer {
    min-height: 80px !important;
  }

  .box_2 {
    margin: 30px auto 0 !important;
  }

  .image_1 {
    margin: -40px auto 0 !important;
    min-height: 300px !important;
  }

  .box_4 {
    padding: 0 10px !important;
  }

  .box_5 {
    padding: 0 10px !important;
  }

  .box_6 {
    padding: 0 10px !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .box_7 {
    padding: 0 10px !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .box_8 {
    padding: 0 10px !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .box_9 {
    width: 100% !important;
    max-width: 100% !important;
  }

  .box_10 {
    padding: 0 10px !important;
  }

  .text-wrapper_1 {
    margin-left: 10px !important;
    gap: 5px !important;
  }

  .box_12 {
    margin-left: 10px !important;
    gap: 5px !important;
  }

  .box_15, .box_16 {
    margin-left: 10px !important;
    gap: 5px !important;
  }

  .product-list-wrapper {
    padding: 0 10px !important;
  }

  .product-list-wrapper .box_17,
  .product-list-wrapper .box_20 {
    flex-direction: column !important;
    align-items: center !important;
    gap: 20px !important;
  }

  .group_4, .group_7, .group_8, .group_9,
  .group_10, .group_11, .group_12, .group_13 {
    max-width: 100% !important;
    width: 100% !important;
  }

  .news-content {
    padding: 30px 15px !important;
    margin: 30px auto 0 !important;
  }

  .news-header {
    margin-bottom: 30px !important;
    padding-bottom: 20px !important;
  }
}

/* 新闻内容区域 - 自适应 */
.news-content {
  width: 100% !important;
  max-width: 1200px !important;
  margin: 42px auto 0 !important;
  padding: 40px 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
}

.news-header {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  margin-bottom: 50px !important;
  padding-bottom: 30px !important;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2) !important;
  box-sizing: border-box !important;
}

.news-title {
  width: auto !important;
  height: auto !important;
  font-size: clamp(28px, 4vw, 36px) !important; /* 响应式字体 */
  font-weight: bold !important;
  color: rgba(0, 149, 151, 1) !important;
  margin: 0 0 10px 0 !important;
  text-align: center !important;
  line-height: 1.2 !important;
}

.news-subtitle {
  width: auto !important;
  height: auto !important;
  font-size: clamp(14px, 1.5vw, 18px) !important; /* 响应式字体 */
  color: #666 !important;
  margin: 0 !important;
  text-align: center !important;
  letter-spacing: 2px !important;
  line-height: 1.2 !important;
}

/* 锁定墓位样式 */
.plot-locked {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
  background-color: #f5f5f5 !important;
}

.plot-text-locked {
  color: #999 !important;
  text-decoration: line-through !important;
}
</style>
